import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const AdultDevelopmentalSessions = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Adult Developmental Sessions
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex-col'>
              <p className='text-black sm:text-justify md:text-xl'>
                {' '}
                well being of adults, our adult developmental sessions are led
                by a team of behaviour therapists, aide workers, occupational
                therapists, psychologists and other support workers to help
                adults gain confidence with their daily functioning capacity,
                target and enhance adult’s communication and social skills, help
                adults gain confidence in social settings, support adults with
                re-associating themselves with their environment and people
                around them and ultimately significantly improves the mental and
                physical health of individuals. These holistic development
                sessions are catered 100% to the needs of the individuals and
                are often useful for those seeking rehabilitation after
                traumatic physical or emotional events.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/adultdevelop.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdultDevelopmentalSessions;
